"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailRegex = void 0;
exports.emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9._%+-]+@([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/;
